// AppointmentTabs.jsx
import React, { useState } from "react";
import Classes from "./AppointmentTabs.module.css";
import ClientDetails from "./ClientDetail";
import VehicleDetails from "./VehicleDetail";
import History from "./History";

export default function AppointmentTabs({ loading, user, bookings, invoices }) {
  const [tab, setTab] = useState("client");

  return (
    <div className={Classes.wrap}>
      <div className={Classes.tabs}>
        <button className={`${Classes.tab} ${tab === "client" ? Classes.active : ""}`} onClick={() => setTab("client")}>Client</button>
        <button className={`${Classes.tab} ${tab === "vehicles" ? Classes.active : ""}`} onClick={() => setTab("vehicles")}>Vehicles</button>
        <button className={`${Classes.tab} ${tab === "history" ? Classes.active : ""}`} onClick={() => setTab("history")}>History</button>
      </div>

      {tab === "client" && <ClientDetails loading={loading} user={user} bookings={bookings} />}
      {tab === "vehicles" && <VehicleDetails loading={loading} user={user} />}
      {tab === "history" && <History loading={loading} bookings={bookings} invoices={invoices} />}
    </div>
  );
}
